module.exports = __webpack_public_path__ + "static/media/add form.91cff316.svg";